var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import HotelOutlinedIcon from "@mui/icons-material/HotelOutlined";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { alpha } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { convertLocalDateToDate, formatFullDMY } from "../../utils/date.util";
import { CommonThemeColors } from "../theme";
import { ElementChip } from "./base/ElementChip";
var STAY_STATUS_CONFIG = {
    CHECKING_IN: {
        label: "Checking in",
        color: CommonThemeColors.sys.success.main,
        Icon: LoginIcon,
    },
    CHECKING_OUT: {
        label: "Checking out",
        color: CommonThemeColors.black,
        Icon: LogoutIcon,
    },
    STAYING: {
        label: "In-House",
        color: CommonThemeColors.sys.info.main,
        Icon: HotelOutlinedIcon,
    },
    UPCOMING: {
        label: "Upcoming",
        color: CommonThemeColors.sys.warning.main,
        Icon: EventAvailableOutlinedIcon,
    },
};
export var getStayStatusDisplay = function (stayStatus) { return stayStatus ? STAY_STATUS_CONFIG[stayStatus] : undefined; };
var formatDate = function (value) {
    if (!value)
        return undefined;
    var date = value instanceof Date
        ? value
        : /^\d{4}-\d{2}-\d{2}$/.test(value)
            ? convertLocalDateToDate(value)
            : new Date(value);
    return date && !Number.isNaN(date.getTime()) ? formatFullDMY(date) : undefined;
};
export function StayStatusElement(_a) {
    var stayStatus = _a.stayStatus, startDate = _a.startDate, endDate = _a.endDate, _b = _a.asPrint, asPrint = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    if (!stayStatus)
        return null;
    var _c = getStayStatusDisplay(stayStatus), label = _c.label, color = _c.color, Icon = _c.Icon;
    var text = t(label);
    if (asPrint) {
        return _jsx(_Fragment, { children: text });
    }
    var formattedStartDate = formatDate(startDate);
    var formattedEndDate = formatDate(endDate);
    var tooltipContent = formattedStartDate || formattedEndDate
        ? (_jsxs(Stack, __assign({ spacing: 0.25 }, { children: [_jsx(Box, __assign({ component: "span", sx: { fontWeight: 600 } }, { children: text })), formattedStartDate && (_jsxs(Box, __assign({ component: "span", sx: { display: 'flex', gap: 0.5 } }, { children: [_jsxs(Box, __assign({ component: "span" }, { children: [t('From'), ":"] })), _jsx(Box, __assign({ component: "span", sx: { fontVariantNumeric: 'tabular-nums' } }, { children: formattedStartDate }))] }))), formattedEndDate && (_jsxs(Box, __assign({ component: "span", sx: { display: 'flex', gap: 0.5 } }, { children: [_jsxs(Box, __assign({ component: "span" }, { children: [t('To'), ":"] })), _jsx(Box, __assign({ component: "span", sx: { fontVariantNumeric: 'tabular-nums' } }, { children: formattedEndDate }))] })))] })))
        : undefined;
    return (_jsx(ElementChip, { text: text, tooltipContent: tooltipContent, startIcon: _jsx(Icon, { sx: { fontSize: 15, color: color } }), borderColor: alpha(color, 0.34), backgroundColor: alpha(color, 0.06) }));
}
